import React from 'react'

import { CourtCaseEventType } from '@app/graphql/types'
import EventBox from '@app/lib/components/EventBox'
import { EVENT_SETTINGS } from '@app/modules/CourtCases/helpers/eventSettings'
import { CourtCaseEventFragment } from '@app/queries/CourtCases/CourtCase.queries'

export type CourtCaseEventBoxProps = {
  event: CourtCaseEventFragment & {
    type?: CourtCaseEventType
  }
}

export const CourtCaseEventBox = ({ event }: CourtCaseEventBoxProps) => {
  const { iconColor: color, icon: IconComponent } = EVENT_SETTINGS[event.type || event.eventType]

  const formatDate = (event: CourtCaseEventFragment) => {
    if (event.date) {
      return new Date(event.date).toLocaleDateString('de-DE', {
        weekday: 'long',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }

    return new Date(event.createdAt).toLocaleDateString('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    })
  }

  return (
    <EventBox
      icon={<IconComponent />}
      color={color}
      heading={event.title!}
      subheading={formatDate(event) || ''}
    />
  )
}
